/**
 * Created by mateo on 5/24/17.
 */

interface isOn {
  up: boolean;
  same: boolean;
  down: boolean;
}

interface Conexion {
  isOn: isOn;
  selfColor: string;
}

export class Unidad {
  public id: number;
  public nombre: string;
  public cursos: any;
  public resumen: string;
  public fechaInicia: string;
  public fechaFin: string;
  public fechaPublicar: string;
  public metas: any;
  public eventos: any;
  public editores: any;
  public materias: any;
  public periodos: any;
  public isActive = true;
  public isEditable = false;
  public isFavorito = false;
  public isIEP = false;
  public isNotificar = false;
  public alumnosIEP: any[] = [];
  public clasesEsperadas: number | string = 0;
  public createdBy = '';
  public periodoId: number;
  public periodo: any;
  public areas: any[];
  public idioma: string;

  public show = true;
  public isConnected: boolean;
  public isConOrig: boolean;
  public setBulk: boolean;
  public isSelected: boolean;
  public indicadores: any;
  public selfColor: string;
  public conexion: Conexion;
  public conexiones;
  public conexionesActivas;
  public comentariosNuevos: number;

  constructor(json?: any) {
    if (json) {
      this.id = json.id || 0;
      this.nombre = json.nombre || '';
      this.cursos = json.cursos || [];
      this.resumen = json.resumen || '';
      this.fechaInicia = json.fechaInicia || '';
      this.fechaFin = json.fechaFin || '';
      this.fechaPublicar = json.fechaPublicar || '';
      this.metas = json.metas || [];
      this.eventos = json.eventos || [];
      this.editores = json.editores || [];
      this.materias = json.materias || [];
      this.periodos = json.periodos || [];
      this.isActive = (typeof json.isActive === 'boolean' ? json.isActive : true);
      this.isEditable = (typeof json.isEditable === 'boolean' ? json.isEditable : false);
      this.isFavorito = (typeof json.isFavorito === 'boolean' ? json.isFavorito : false);
      this.isNotificar = json.isNotificar || false;
      this.clasesEsperadas = json.clasesEsperadas || 0;
      this.createdBy = json.createdBy || '';
      this.periodo = json.periodo || {};
      this.isIEP = (typeof json.isIEP === 'boolean' ? json.isIEP : false);
      this.alumnosIEP = json.alumnosIEP || [];
      this.indicadores = [];
      this.idioma = json.idioma || 'es';
      this.conexion = { isOn: { up: false, same: false, down: false }, selfColor: '' };
      this.conexiones = json.conexiones || {
        status: { up: false, same: false, down: false },
        active: false,
        selfColor: '',
        activeColor: ''
      };
      this.conexionesActivas = json.conexionesActivas || [];
      this.comentariosNuevos = json.comentariosNuevos || 0;
    }
  }

  public visibility(val: boolean) {
    this.show = val;
  }

  public getCodigo() {
    return this.nombre;
  }
}
